import { useEffect, useState } from 'react'

import Api from 'services/api'
import { SystemConfiguration } from 'types/SystemConfigReport'

const useSystemConfiguration = (deviceId: string) => {
  const [systemConfiguration, setSystemConfiguration] = useState<SystemConfiguration | null>(null)
  const [areSystemConfigurationLoaded, setAreSystemConfigurationLoaded] = useState(false)

  useEffect(() => {
    setAreSystemConfigurationLoaded(false)

    Api.SystemConfig.get(deviceId)
      .then((res: SystemConfiguration | null) => {
        setSystemConfiguration((res))
      }).catch(() => {
        setSystemConfiguration(null)
      }).finally(() => {
        setAreSystemConfigurationLoaded(true)
      })
  }, [deviceId])

  return { systemConfiguration, areSystemConfigurationLoaded }
}

export default useSystemConfiguration
